<template>
    <v-app id="app" :class="$vuetify.breakpoint.mobile ? 'mobile' : ''">
        <meta :version="version" />
        <v-navigation-drawer
                             v-cloak
                             v-if="$route.name && !$route.name.match(/catchall|branfts/) && !($route.name.match(/branft/) && $route.query.screenshot !== undefined)"
                             v-model="navigation"
                             app
                             :permanent="!$vuetify.breakpoint.mobile"
                             :disable-route-watcher="$vuetify.breakpoint.mobile"
                             :mini-variant="mini"
                             :expand-on-hover="$vuetify.breakpoint.mobile ? false : true">
            <v-btn text v-show="$vuetify.breakpoint.mobile && !mini" @click="mini = true" style="float: right">X</v-btn>
            <v-list nav dense>
                <v-list-item @click.prevent="$auth.isAuthenticated ? logout() : login()">
                    <v-list-item-icon v-if="!$auth.isAuthenticated">
                        <v-icon>{{ $auth.isAuthenticated ? mdiLogoutVariant : mdiLoginVariant }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-avatar :size="40" style="left: -8px" rounded v-else>
                        <v-img :src="$auth.user.picture"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{ $auth.isAuthenticated ? 'Logout' : 'Login' }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-divider v-if="$auth.isAuthenticated"></v-divider>
            <v-list v-if="$auth.isAuthenticated" nav dense>
                <v-subheader v-if="!$vuetify.breakpoint.mobile && $auth.isAuthenticated" inset>Account</v-subheader>
                <v-list-item v-if="$auth.isAuthenticated && $auth.user[`https://${tld}/roles`] && !$auth.user[`https://${tld}/roles`].includes('collector')" to="/account#nft">
                    <v-list-item-icon>
                        <icon-base height="25" width="25" viewBox="-20 0 100 100" icon-name="b" class="d-flex align-center">
                            <icon-b iconColor="rgb(213, 0, 0, 1)" />
                        </icon-base>
                    </v-list-item-icon>
                    <v-list-item-title>Studio, Store, Gallery</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="$auth.isAuthenticated && $auth.user[`https://${tld}/roles`] && !$auth.user[`https://${tld}/roles`].includes('collector')" to="/account#wishlist">
                    <v-list-item-icon>
                        <i class="material-icons">format_list_numbered</i>
                    </v-list-item-icon>
                    <v-list-item-title>Wish List</v-list-item-title>
                </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-list nav dense>
                <v-list-item to="/gallery">
                    <v-list-item-icon>
                        <v-icon>{{ mdiViewGallery }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Gallery</v-list-item-title>
                </v-list-item>
                <v-list-item to="/commissions">
                    <v-list-item-icon>
                        <v-icon>{{ mdiPaletteAdvanced }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Commissions</v-list-item-title>
                </v-list-item>
                <v-list-item to="/wishlists">
                    <v-list-item-icon>
                       <i class="material-icons">list</i>
                    </v-list-item-icon>
                    <v-list-item-title>Wish Lists</v-list-item-title>
                </v-list-item>
                <v-list-item to="/faq">
                    <v-list-item-icon>
                        <v-icon>{{ mdiHelpCircleOutline }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>FAQ</v-list-item-title>
                </v-list-item>
                <v-list-item to="/support">
                    <v-list-item-icon>
                        <v-icon>{{ mdiAt }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Help</v-list-item-title>
                </v-list-item>
                <v-list-item @click="creditButtonHandler">
                    <v-list-item-icon class="justify-center">
                        <v-icon light>{{ mdiCopyright }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Credits</v-list-item-title>
                </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-list nav dense>
                <v-list-item :href="walletUrl" rel="noopener" target="_blank">
                    <v-list-item-icon>
                        <icon-base height="25" width="25" viewBox="20 40 150 150" icon-name="near" class="d-flex align-center">
                            <icon-near iconColor="rgba(0, 0, 0, 1)" />
                        </icon-base>
                    </v-list-item-icon>
                    <v-list-item-title>NEAR Wallet</v-list-item-title>
                </v-list-item>
                <v-list-item href="https://discord.gg/YCVyvEmg4b" rel="noopener" target="_blank">
                    <v-list-item-icon>
                        <v-icon class="material-icons">discord</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Discord</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-main>
            <keep-alive v-if="NODE_ENV === 'production'">
                <router-view :key="$route.fullPath" />
            </keep-alive>
            <router-view v-else :key="$route.fullPath" />
        </v-main>
        <v-snackbar color="secondary" text :timeout="-1" v-model="notice">
            <v-row>
                <v-col cols="1" class="d-flex align-center justify-center">
                    <v-icon :x-small="$vuetify.breakpoint.mobile">{{ mdiInformationOutline }}</v-icon>
                </v-col>
                <v-col cols="10" class="d-flex align-center justify-center">
                    <span class="font-weight-light" v-bind:class="$vuetify.breakpoint.mobile ? 'caption' : ''">Reload to update to the newest app version.</span>
                </v-col>
                <v-col cols="1" class="d-flex align-center justify-center">
                    <v-btn text :x-small="$vuetify.breakpoint.mobile" @click="clickHandler"> X </v-btn>
                </v-col>
            </v-row>
        </v-snackbar>
        <v-alert :type="alertType" dense prominent dismissible v-model="alert[alertType].visible" :icon="alert[alertType].icon" class="mb-0 mr-0" :class="$vuetify.breakpoint.mobile ? 'px-0 py-2' : ''">
            <template v-slot:prepend>
                <v-icon v-if="$vuetify.breakpoint.mobile" class="v-alert__icon ml-4">{{ alert[alertType].icon }}</v-icon>
                <div v-else></div>
            </template>
            <template v-slot:close>
                <v-btn small v-if="$vuetify.breakpoint.mobile" @click="alert[alertType].visible = false" class="d-flex mr-4">Dismiss</v-btn>
                <div v-else></div>
            </template>
            <v-row align="center">
                <v-spacer v-if="!$vuetify.breakpoint.mobile" cols="3"></v-spacer>
                <v-col v-if="!$vuetify.breakpoint.mobile" class="shrink">
                    <v-icon class="v-alert__icon">{{ alert[alertType].icon }}</v-icon>
                </v-col>
                <v-col class="grow">
                    <span class="error-message overline" v-html="alert[alertType].message"></span>
                </v-col>
                <v-col v-if="!$vuetify.breakpoint.mobile" class="shrink">
                    <v-btn @click="alert[alertType].visible = false" class="d-flex ml-auto">Dismiss</v-btn>
                </v-col>
                <v-spacer cols="3"></v-spacer>
            </v-row>
        </v-alert>
        <v-overlay opacity="0.9" v-click-outside="onClickOutside" :value="showCredits">
            <v-col class="text-center font-weight-light" cols="12">
                <h4 class="text-capitalize text-h3 font-weight-light mb-4">Attributions and Credits</h4>
                <div v-for="credit of credits" v-bind:key="credit" v-html="credit" />
            </v-col>
            <v-snackbar :value="true" timeout="0">
                <p class="text-center font-weight-light mb-0">2022 BraNFT™</p>
            </v-snackbar>
        </v-overlay>
        <v-btn v-scroll="scrollingHandler" v-if="$route.name && !$route.name.match(/catchall|branfts/) && !($route.name.match(/branft/) && $route.query.screenshot !== undefined)" fab small v-show="!navigation" @click.stop="$root.$emit('navigation-menu')" id="nav-menu-button">
            <v-icon color="primary">{{ mdiMenu }}</v-icon>
        </v-btn>
    </v-app>
</template>
<style scoped>
.v-alert {
    z-index: 6;
    width: 100%;
    position: fixed;
    bottom: 0;
}
#nav-menu-button {
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    z-index: 9 !important;
}
</style>
<style>
a.white-no-decoration {
    text-decoration: none;
    color: white !important;
}
.error-message > sup > a {
    text-decoration: none;
    color: white;
}
sup > a.white-no-decoration {
    text-decoration: none;
    color: white;
}
.mobile.v-application .text-overline {
    font-size: 0.65rem !important;
}
.mobile-paragraphs {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}
sub {
    font-size: 60%;
}
/**
@font-face {
    font-family: "Allura";
    font-style: normal;
    font-weight: 400;
    font-display: block;
    src: url("https://fonts.gstatic.com/s/allura/v10/9oRPNYsQpS4zjuA_iwgW.woff2")
        format("woff2");
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
        U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
        U+2215, U+FEFF, U+FFFD;
}*/
#app
    > div
    > nav
    > div.v-navigation-drawer__content
    > div:nth-child(5)
    > a:nth-child(2)
    > div.v-list-item__icon
    > svg {
    transform: rotate(90deg);
}
#app.v-overlay__content {
    width: 100%;
    margin-left: 200px;
}
#app.v-overlay {
    align-items: unset;
}
.close {
    float: right;
    margin: 5px 10px;
    cursor: pointer;
}
.attributes {
    font-size: xx-small;
}
[v-cloak] {
    display: none !important;
}
.v-application {
    font-stretch: condensed;
}
</style>
<script>
import IconB from "./components/IconB.vue";
import IconBase from "./components/IconBase.vue";
import IconNear from "./components/IconNear.vue";
import {
    mdiDiscord,
    mdiMagnify,
    mdiDotsGrid,
    mdiFormatListBulleted,
    mdiPlaylistStar,
    mdiHelpCircleOutline,
    mdiAt,
    mdiDownload,
    mdiLoginVariant,
    mdiLogoutVariant,
    mdiInformation,
    mdiInformationOutline,
    mdiAlert,
    mdiMenu,
    mdiViewGallery,
    mdiCopyright,
    mdiPaletteAdvanced,
} from "@mdi/js";

export default {
    components: {
        IconBase,
        IconB,
        IconNear,
    },
    data: function () {
        return {
            tld: global.tld,
            version: undefined,
            notice: false,
            versionCheckIntervalId: undefined,
            navigation: false,
            mini: true,
            credits: [
                `<div>File uploads <a target="_blank" href="https://pqina.nl" rel="noopener" title="Powered by PQINA">Powered by PQINA</a></div>`,
            ],
            showCredits: false,
            mdiDiscord,
            mdiMagnify,
            mdiDotsGrid,
            mdiFormatListBulleted,
            mdiPlaylistStar,
            mdiHelpCircleOutline,
            mdiAt,
            mdiDownload,
            mdiLoginVariant,
            mdiLogoutVariant,
            mdiInformation,
            mdiInformationOutline,
            mdiMenu,
            mdiAlert,
            mdiViewGallery,
            mdiPaletteAdvanced,
            mdiCopyright,
            showCreditsDebounce: true,
            alertType: "error",
            alert: {
                error: {
                    icon: mdiAlert,
                    visible: false, //process.env.NODE_ENV === 'production' ? false : true,
                    message: "unknown error",
                },
                info: {
                    icon: mdiInformation,
                    visible: false,
                    message: "unknown information",
                },
            },
            timeouts: {
                scrollHandler: null,
                hiddenFab: null,
            },
            chosenUsername: undefined,
            error: {}
        };
    },
    methods: {
        scrollingHandler: function (window) {
            if (this.timeouts.scrollHandler) return;
            const self = this;
            const fabButton = window.target.getElementById("nav-menu-button");
            fabButton.style.removeProperty("display");
            self.timeouts.hiddenFab = setTimeout(() => {
                self.timeouts.scrollHandler = clearTimeout(
                    self.timeouts.scrollHandler
                );
                self.timeouts.hiddenFab = clearTimeout(self.timeouts.hiddenFab);
            }, 500);
            self.timeouts.hiddenFab = setTimeout(() => {
                fabButton.style.setProperty("display", "none");
                self.timeouts.hiddenFab = clearTimeout(self.timeouts.hiddenFab);
            }, 3000);
        },
        creditButtonHandler: function () {
            const self = this;
            self.showCredits = !self.showCredits;
            self.showCreditsDebounce = false;
            setTimeout(() => {
                self.showCreditsDebounce = true;
            }, 500);
        },
        onClickOutside: function () {
            if (this.showCreditsDebounce) this.showCredits = false;
        },
        clickHandler: function () {
            this.notice = false;
            clearInterval(this.versionCheckIntervalId);
        },
        login: function (signup = false) {
            this.$auth.loginWithRedirect({
                screen_hint: signup ? "signup" : "",
                appState: { targetUrl: this.$route.fullPath },
            });
        },
        logout: function () {
            this.$auth.logout();
            this.$near.signOut();
        },
        createFormError: function (error) {
            this.error.alert = true;
            this.error.message = error instanceof Error ? error.message : error;
        },
        alertHandler: function (alertType, name, message) {
            const self = this;
            switch (name) {
                case "unverifiedUserError":
                    self.alert[
                        alertType
                    ].message = `You must verify yourself first.
                    <sup><a target="_blank" rel="noopener" href="https://branfts.com/faq?id=61f01804accc01000142b9fa">(What?)</a></sup>
                    `;
                    break;
                case "recoveryRequestSent":
                    self.alert[alertType].message = `A recovery email was sent.
                    <sup><a target="_blank" rel="noopener" href="https://branfts.com/faq?id=620fe663accc01000142bacb">(What?)</a></sup>
                    `;
                    break;
                case "nearUserRejected":
                case "userRejected":
                    self.alert[alertType].message = message;
                    break;
                default:
                    self.alert[alertType].message = message;
                    break;
            }
            self.$set(self, "alertType", alertType);
            self.$set(self.alert[alertType], "visible", true);
        },
    },
    computed: {
        NODE_ENV: () => {
            return process.env.NODE_ENV;
        },
        walletUrl() {
            return process.env.VUE_APP_NEAR_NETWORK === "mainnet"
                ? `https://wallet.near.org/`
                : `https://wallet.testnet.near.org/`;
        },
    },
    mixins: [
        {
            methods: {
                signupButtonHandler: async function (options = {}) {
                    const defaultOptions = {
                        appState: { targetUrl: this.$route.fullPath },
                        username_hint: this.chosenUsername
                            ? this.chosenUsername
                            : undefined,
                    };
                    try {
                        await this.$auth.loginWithPopup({
                            ...options,
                            ...defaultOptions,
                        });
                        if (defaultOptions.username_hint) {
                            this.$router.push({
                                path: "/account#nft-create?welcome=braNFT",
                            });
                        } else {
                            this.$auth.getTokenSilently();
                        }
                    } catch (error) {
                        this.$emit("error", error);
                    }
                },
            },
        },
        {
            name: "copy",
            data: function () {
                return {
                    tld: document.domain.match(/[^.]*.com/)[0],
                    debounce: false,
                    tooltip: {},
                };
            },
            methods: {
                async copy(text, tooltipId = text) {
                    let self = this;
                    if (self.debounce) return;
                    self.debounce = true;
                    self.$set(self.tooltip, tooltipId, true);
                    try {
                        await navigator.clipboard.writeText(text);
                    } catch (error) {
                        console.log({error});
                        self.debounce = false;
                        self.tooltip[tooltipId] = false;
                    }
                    setTimeout(() => {
                        self.debounce = false;
                    }, 100);
                    setTimeout(() => {
                        self.tooltip[tooltipId] = false;
                    }, 1500);
                },
            },
        },
    ],
    mounted() {
        const self = this;
        if (this.NODE_ENV !== "production") {
            console.log(this.$vuetify.breakpoint);
        }
        let lastBuild;
        this.versionCheckIntervalId = setInterval(
            async () => {
                const newestBuild = await self.$backend.buildInfo();
                self.version = newestBuild.commit_sha;
                if (
                    lastBuild &&
                    lastBuild.build_date !== newestBuild.build_date
                ) {
                    self.notice = true;
                } else {
                    lastBuild = newestBuild;
                }
            },
            process.env.NODE_ENV !== "production" ? 60000 : 60000
        );
        this.$root.$on("createFormError", this.createFormError);
        this.$root.$on("unverifiedUserError", () =>
            this.alertHandler("error", "unverifiedUserError")
        );
        this.$root.$on("recoveryRequestSent", () =>
            this.alertHandler("info", "recoveryRequestSent")
        );
        this.$root.$on("nearUserRejected", (message) =>
            this.alertHandler("error", "nearUserRejected", message)
        );
        this.$root.$on("navigation-menu", () => (this.navigation = true));
        this.$root.$on("userRejected", (message) =>
            this.alertHandler("error", "userRejected", message)
        );
        this.$root.$on("commissionError", (message) =>
            this.alertHandler("error", "commissionError", message)
        );
    },
};
</script>
